var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-сontributing-organizations_item-logo"},[_c('img',{staticClass:"ui-сontributing-organizations_item-logo-img hover",attrs:{"src":require("@/assets/scss/images/bcg-logo.svg"),"alt":"BCG"}}),_c('img',{staticClass:"ui-сontributing-organizations_item-logo-img default",attrs:{"src":require("@/assets/scss/images/bcg-logo-blue.svg"),"alt":"BCG"}})])
}]

export { render, staticRenderFns }